import { IconWrapper } from '../runtime';
export default IconWrapper('qrcode-sharing-one', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "fill": "none",
      "height": props.size,
      "viewBox": "0 0 48 48",
      "width": props.size
    }
  }, [h("filter", {
    "attrs": {
      "id": props.id + '92c4d12b',
      "color-interpolation-filters": "sRGB",
      "filterUnits": "userSpaceOnUse",
      "height": "48",
      "width": "48",
      "x": "0",
      "y": "0"
    }
  }, [h("feFlood", {
    "attrs": {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), h("feBlend", {
    "attrs": {
      "in": "SourceGraphic",
      "in2": "BackgroundImageFix",
      "mode": "normal",
      "result": "shape"
    }
  }), h("feColorMatrix", {
    "attrs": {
      "in": "SourceAlpha",
      "result": "hardAlpha",
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }
  }), h("feOffset", {
    "attrs": {
      "dy": "-1.125"
    }
  }), h("feComposite", {
    "attrs": {
      "in2": "hardAlpha",
      "k2": "-1",
      "k3": "1",
      "operator": "arithmetic"
    }
  }), h("feColorMatrix", {
    "attrs": {
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
    }
  }), h("feBlend", {
    "attrs": {
      "in2": "shape",
      "mode": "normal",
      "result": "effect1_innerShadow_961_216"
    }
  })]), h("linearGradient", {
    "attrs": {
      "id": props.id + '6efd24a6',
      "gradientUnits": "userSpaceOnUse",
      "x1": "48",
      "x2": "0",
      "y1": "48",
      "y2": "0"
    }
  }, [h("stop", {
    "attrs": {
      "offset": ".029618",
      "stop-color": "#547aff"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#339dff"
    }
  })]), h("clipPath", {
    "attrs": {
      "id": props.id + '4b5a4879'
    }
  }, [h("path", {
    "attrs": {
      "d": "m0 0h48v48h-48z"
    }
  })]), h("g", {
    "attrs": {
      "clip-path": 'url(#' + props.id + '4b5a4879' + ')'
    }
  }, [h("g", {
    "attrs": {
      "filter": 'url(#' + props.id + '92c4d12b' + ')'
    }
  }, [h("path", {
    "attrs": {
      "d": "m24 48c-13.254 0-24-10.746-24-24s10.746-24 24-24 24 10.746 24 24-10.746 24-24 24z",
      "fill": 'url(#' + props.id + '6efd24a6' + ')'
    }
  })]), h("path", {
    "attrs": {
      "d": "m19.5 12h-4.5c-.7956 0-1.5587.3161-2.1213.8787s-.8787 1.3257-.8787 2.1213v4.5c0 .7956.3161 1.5587.8787 2.1213s1.3257.8787 2.1213.8787h4.5c.7956 0 1.5587-.3161 2.1213-.8787s.8787-1.3257.8787-2.1213v-4.5c0-.7956-.3161-1.5587-.8787-2.1213s-1.3257-.8787-2.1213-.8787zm-4.5 3h4.5v4.5h-4.5zm18-3h-4.5c-.7956 0-1.5587.3161-2.1213.8787s-.8787 1.3257-.8787 2.1213v4.5c0 .7956.3161 1.5587.8787 2.1213s1.3257.8787 2.1213.8787h4.5c.7956 0 1.5587-.3161 2.1213-.8787s.8787-1.3257.8787-2.1213v-4.5c0-.7956-.3161-1.5587-.8787-2.1213s-1.3257-.8787-2.1213-.8787zm-4.5 3h4.5v4.5h-4.5zm-9 10.5h-4.5c-.7956 0-1.5587.3161-2.1213.8787s-.8787 1.3257-.8787 2.1213v4.5c0 .7956.3161 1.5587.8787 2.1213s1.3257.8787 2.1213.8787h4.5c.7956 0 1.5587-.3161 2.1213-.8787s.8787-1.3257.8787-2.1213v-4.5c0-.7956-.3161-1.5587-.8787-2.1213s-1.3257-.8787-2.1213-.8787zm-4.5 3h4.5v4.5h-4.5zm10.5 4.5h3v3h-3zm7.5-7.5h3v3h-3zm-3 7.5h3v3h-3zm-4.5-7.5h3v6h-3zm3 0h3v3h-3zm4.5 4.5h3v6h-3z",
      "fill": "#fff"
    }
  })])]);
});